webpackJsonp([0],{

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationLogging_vue__ = __webpack_require__(714);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa0b572_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationLogging_vue__ = __webpack_require__(877);
function injectStyle (ssrContext) {
  __webpack_require__(861)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fa0b572"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReservationLogging_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa0b572_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReservationLogging_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(498), __esModule: true };

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36);
__webpack_require__(25);
module.exports = __webpack_require__(499);


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var get = __webpack_require__(58);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export syncApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




var _guardCallback = function _guardCallback(arg) {
  if (typeof arg === "function") {
    arg();
  }
};

var _onError = function _onError(error) {
  if (error.response) {
    if (error.response.data.errors) {
      if (Array.isArray(error.response.data.errors)) {
        for (var index = 0; index < error.response.data.errors.length; index++) {
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[index], {
            title: "Error"
          });
        }
      } else {
        for (var prop in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(prop)) {
            continue;
          }
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[prop][0], {
            title: "Error"
          });
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Request failed with status code " + error.response.status, { title: "Error" });
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something wrong with request messages.", {
      title: "Error"
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something went wrong, please try again later.", {
      title: "Error"
    });
  }

  return {
    isSuccess: false
  };
};

var syncApi = {
  get: function get(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  post: function post(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  put: function put(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  delete: function _delete(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  getWithOptions: function getWithOptions(url, option, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  postWithOptions: function postWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  putWithOptions: function putWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  }
};

var asyncApi = {
  get: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _guardCallback(onBeginCallback);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _onError(_context.t0));

            case 11:
              _context.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 11, 14]]);
    }));

    return function get(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  post: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _guardCallback(onBeginCallback);
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", onErrorCallback(_context2.t0.response.data));

            case 12:
              return _context2.abrupt("return", _onError(_context2.t0));

            case 13:
              _context2.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8, 13, 16]]);
    }));

    return function post(_x4, _x5, _x6, _x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }(),
  put: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _guardCallback(onBeginCallback);
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", onErrorCallback(_context3.t0.response.data));

            case 12:
              return _context3.abrupt("return", _onError(_context3.t0));

            case 13:
              _context3.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8, 13, 16]]);
    }));

    return function put(_x9, _x10, _x11, _x12, _x13) {
      return _ref3.apply(this, arguments);
    };
  }(),
  delete: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _guardCallback(onBeginCallback);
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", _onError(_context4.t0));

            case 11:
              _context4.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context4.finish(11);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[0, 8, 11, 14]]);
    }));

    return function _delete(_x14, _x15, _x16) {
      return _ref4.apply(this, arguments);
    };
  }(),
  getWithOptions: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url, option, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              _guardCallback(onBeginCallback);
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", _onError(_context5.t0));

            case 11:
              _context5.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context5.finish(11);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[0, 8, 11, 14]]);
    }));

    return function getWithOptions(_x17, _x18, _x19, _x20) {
      return _ref5.apply(this, arguments);
    };
  }(),
  postWithOptions: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              _guardCallback(onBeginCallback);
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", _onError(_context6.t0));

            case 11:
              _context6.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context6.finish(11);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[0, 8, 11, 14]]);
    }));

    return function postWithOptions(_x21, _x22, _x23, _x24, _x25) {
      return _ref6.apply(this, arguments);
    };
  }(),
  putWithOptions: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              _guardCallback(onBeginCallback);
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _onError(_context7.t0));

            case 11:
              _context7.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context7.finish(11);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this, [[0, 8, 11, 14]]);
    }));

    return function putWithOptions(_x26, _x27, _x28, _x29, _x30) {
      return _ref7.apply(this, arguments);
    };
  }()
};



/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["autocomplete"]
});

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export arrayContainElement */
/* unused harmony export allowedPermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return allowToViewCustomerNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return allowToViewAdminNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return allowToAddEditAdminNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allowRepricingAirportTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return allowRepricingHourly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return companySelectorAirportTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return companySelectorHourly; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_constants__ = __webpack_require__(237);


var arrayContainElement = function arrayContainElement(arrayValue) {
  return arrayValue && arrayValue !== null;
};

var allowedPermission = function allowedPermission(currentUserPermission, permissionGroup, permission) {
  return arrayContainElement(currentUserPermission) && currentUserPermission[permissionGroup].includes(permission);
};

var allowToViewCustomerNotes = function allowToViewCustomerNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewCustomerNote");
};

var allowToViewAdminNotes = function allowToViewAdminNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewAdminNote");
};

var allowToAddEditAdminNotes = function allowToAddEditAdminNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "AddEditAdminNote");
};

var allowRepricingAirportTransfer = function allowRepricingAirportTransfer(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "Reprice") && allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewRepriceHistory");
};

var allowRepricingHourly = function allowRepricingHourly(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].HourlyReservation, "Reprice") && allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].HourlyReservation, "ViewRepriceHistory");
};

var companySelectorAirportTransfer = function companySelectorAirportTransfer(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].InquiryAvailability, "CompanySelector");
};

var companySelectorHourly = function companySelectorHourly(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].InstantAvailability, "CompanySelector");
};

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



var _canvas = void 0;
var _marker = void 0;
var _markers = [];
var _circle = void 0;
var _infoWindow = void 0;
var _hasAutocomplete = false;
var _hasMarker = false;
var _hasInfoWindow = false;
var _hasConfirmLocationCallback = false;
var _hasRemoveLocationCallback = false;
var _hasDrawGeometryCallback = false;
var _hasAutoCompleteGetPlaceCallback = false;
var _hasMarkerChangeCallback = false;
var _confirmLocationClassName = "save-location";
var _removeLocationClassName = "remove-location";
var _drawGeometryLocationClassName = "draw-geometry";

function _isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function _onClickCanvas(latLng) {
  _marker.setPosition(latLng);
  _marker.setVisible(true);
}

function _onPlaceChangedAutoComplete(autocomplete) {
  // hide marker
  if (_hasMarker) {
    _marker.setVisible(false);
  }

  var place = autocomplete.getPlace();
  if (!place.geometry) {
    // User entered the name of a Place that was not suggested and
    // pressed the Enter key, or the Place Details request failed.
    window.alert("No details available for input: '" + place.name + "'");
    return;
  }

  // If the place has a geometry, then present it on a map.
  if (place.geometry.viewport) {
    _canvas.fitBounds(place.geometry.viewport);
  } else {
    _canvas.setCenter(place.geometry.location);
  }

  _canvas.setZoom(15);

  // display marker
  if (_hasMarker) {
    _marker.setPosition(place.geometry.location);
    _marker.setVisible(true);
  }

  return place;
}

function _removeCircle() {
  if (_circle !== undefined) {
    _circle.setMap(null);
  }
}

function _removeInfoWindow() {
  if (_infoWindow !== undefined) {
    _infoWindow.close();
  }
}

function _initializeCircle(coordinate, visibleCircle) {
  // remove existing objects
  _removeCircle();
  _removeInfoWindow();

  // draw circle
  _circle = new google.maps.Circle({
    center: {
      lat: coordinate.lat,
      lng: coordinate.lng
    },
    radius: coordinate.rad,
    editable: true,
    draggable: true
  });

  // fill on canvas
  if (visibleCircle) {
    var showInfoWindow = function showInfoWindow() {
      var content = "Latitude: " + _circle.getCenter().lat() + "<br>" + "Longitude: " + _circle.getCenter().lng() + "<br>" + "Radius: " + _circle.getRadius().toString();

      // Set the info window's content and position.
      _infoWindow.setContent(content);
      _infoWindow.setPosition(_circle.getBounds().getNorthEast());
      _infoWindow.open(_canvas);
    };

    // attach listener


    _circle.setMap(_canvas);

    // create window
    _infoWindow = new google.maps.InfoWindow();

    _circle.addListener("radius_changed", showInfoWindow);
    _circle.addListener("center_changed", showInfoWindow);
  }
}

var MaverickMap = function () {
  function MaverickMap(config) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MaverickMap);

    // mapId: string
    // lat: double
    // lng: double
    // autocomplete: bool
    // marker: bool
    // infoWindow: bool
    // confirmLocationCallback: callback
    // removeLocationCallback: callback
    // drawGeometryCallback: callback
    // autoCompleteGetPlaceCallback: callback
    // markerChangeCallback: callback
    // confirmLocationClassName: string
    // removeLocationClassName: string
    // drawGeometryLocationClassName: string
    this.config = config;
    this.enableMarkerClick = config.enableMarkerClick !== false;

    _hasAutocomplete = config.autocomplete !== undefined && config.autocomplete === true;
    _hasMarker = config.marker !== undefined && config.marker === true;
    _hasInfoWindow = config.infoWindow !== undefined && config.infoWindow === true;
    _hasConfirmLocationCallback = config.confirmLocationCallback !== undefined;
    _hasRemoveLocationCallback = config.removeLocationCallback !== undefined;
    _hasDrawGeometryCallback = config.drawGeometryCallback !== undefined;
    _hasAutoCompleteGetPlaceCallback = config.autoCompleteGetPlaceCallback !== undefined;
    _hasMarkerChangeCallback = config.markerChangeCallback !== undefined;
    _confirmLocationClassName = config.confirmLocationClassName !== config.confirmLocationClassName ? config.confirmLocationClassName : _confirmLocationClassName;
    _removeLocationClassName = config.removeLocationClassName !== config.removeLocationClassName ? config.removeLocationClassName : _removeLocationClassName;
    _drawGeometryLocationClassName = config.drawGeometryLocationClassName !== config.drawGeometryLocationClassName ? config.drawGeometryLocationClassName : _drawGeometryLocationClassName;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MaverickMap, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;

      // reset
      _canvas = undefined;
      _marker = undefined;
      _circle = undefined;
      _infoWindow = undefined;

      if (_isEmpty(this.config)) {
        return;
      }

      _canvas = new google.maps.Map(document.getElementById(this.config.mapId), {
        center: {
          lat: this.config.lat,
          lng: this.config.lng
        },
        zoom: 15,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      });

      _canvas.addListener("bounds_changed", function () {
        var container = document.getElementsByClassName("pac-container")[0];
        if (container !== undefined && container !== null) {
          container.setAttribute("style", "z-index: 2000;");
        }
      });

      // Marker
      if (_hasMarker) {
        _marker = new google.maps.Marker({
          map: _canvas,
          anchorPoint: new google.maps.Point(0, -29)
        });

        // attach event listener
        if (this.enableMarkerClick) {
          _canvas.addListener("click", function (e) {
            var latLng = e.latLng;
            _onClickCanvas(latLng);
            if (_hasMarkerChangeCallback) {
              _this.config.markerChangeCallback({
                lat: latLng.lat(),
                lng: latLng.lng()
              });
            }
          });
        }
      }

      // Autocomplete
      if (_hasAutocomplete) {
        _canvas.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById("pac-card"));

        var autocomplete = new google.maps.places.Autocomplete(document.getElementById("pac-input"));

        // Bind the map's bounds (viewport) property to the autocomplete object,
        // so that the autocomplete requests use the current map bounds for the
        // bounds option in the request.
        autocomplete.bindTo("bounds", _canvas);

        // Set the data fields to return when the user selects a place.
        autocomplete.setFields(["address_components", "formatted_address", "geometry", "name", "place_id"]);

        // attach event listener
        autocomplete.addListener("place_changed", function (_) {
          var place = _onPlaceChangedAutoComplete(autocomplete);
          if (_hasAutoCompleteGetPlaceCallback) {
            _this.config.autoCompleteGetPlaceCallback(place);
          }
        });
      }

      var customControl = document.getElementById("gmap-custom-control");
      if (customControl) {
        // EventHandler: Save Location
        var saveLocationControl = customControl.getElementsByClassName(_confirmLocationClassName);
        if (_hasConfirmLocationCallback && saveLocationControl.length > 0) {
          saveLocationControl[0].addEventListener("click", function () {
            var coordinate = {};
            if (_marker !== undefined) {
              coordinate.lat = _marker.getPosition().lat();
              coordinate.lng = _marker.getPosition().lng();
            } else if (_circle !== undefined) {
              coordinate.lat = _circle.getCenter().lat();
              coordinate.lng = _circle.getCenter().lng();
              coordinate.rad = _circle.getRadius();
            }

            // callback
            _this.config.confirmLocationCallback(coordinate);
          });
        }

        // EventHandler: Remove Location
        var removeLocationControl = customControl.getElementsByClassName(_removeLocationClassName);
        if (_hasRemoveLocationCallback && removeLocationControl.length > 0) {
          removeLocationControl[0].addEventListener("click", function () {
            // remove objects
            _this.hideMarker();
            _removeCircle();
            _removeInfoWindow();

            // callback
            _this.config.removeLocationCallback();
          });
        }

        // EventHandler: Draw Geometry
        var drawGeometryControl = customControl.getElementsByClassName(_drawGeometryLocationClassName);
        if (_hasDrawGeometryCallback && drawGeometryControl.length > 0) {
          drawGeometryControl[0].addEventListener("click", function () {
            _initializeCircle({
              lat: _canvas.getCenter().lat(),
              lng: _canvas.getCenter().lng(),
              rad: 700
            }, true);
          });
        }
      }
    }
  }, {
    key: "showInfoWindow",
    value: function showInfoWindow(position, content) {
      if (_hasInfoWindow) {
        // initialize if empty
        if (_infoWindow === undefined) {
          _infoWindow = new google.maps.InfoWindow();
        }

        var latLng = new google.maps.LatLng(position.latitude, position.longitude);

        // Set the info window's content and position.
        _infoWindow.setContent(content);
        _infoWindow.setPosition(latLng);
        _infoWindow.open(_canvas);

        _canvas.setCenter(latLng);
        _canvas.setZoom(20);
      }
    }
  }, {
    key: "showMarker",
    value: function showMarker(center) {
      var iconUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // if (_hasMarker) {
      //   _marker.setPosition(center);
      //   _marker.setVisible(true);
      // }

      if (_hasMarker) {
        // Hapus marker lama jika ada
        if (_marker) {
          _marker.setMap(null);
        }

        // Buat marker baru
        var markerOptions = {
          position: center,
          map: _canvas
        };

        if (iconUrl) {
          markerOptions.icon = {
            url: iconUrl
          };
        }

        _marker = new google.maps.Marker(markerOptions);
        _marker.setVisible(true);
      }
      _canvas.setCenter(center);
      _canvas.setZoom(15);
    }
  }, {
    key: "hideMarker",
    value: function hideMarker() {
      if (_hasMarker) {
        _marker.setVisible(false);
      }
      _canvas.setZoom(15);
    }
  }, {
    key: "setCircleCenter",
    value: function setCircleCenter(center, radius, visibleCircle) {
      if (_circle === undefined) {
        _initializeCircle({
          lat: center.lat(),
          lng: center.lng(),
          rad: radius
        }, visibleCircle);
      } else {
        _circle.setCenter(center);
        _circle.setRadius(radius);
      }
      _canvas.fitBounds(_circle.getBounds());
      _canvas.setZoom(12);
    }
  }, {
    key: "addMarker",
    value: function addMarker(_ref) {
      var lat = _ref.lat,
          lng = _ref.lng,
          icon = _ref.icon;
      var infoContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: _canvas,
        anchorPoint: new google.maps.Point(0, -29),
        icon: {
          url: icon ? icon : "/static/assets/images/dot-marker.svg",
          scaledSize: new google.maps.Size(35, 35)
        }
      });
      _markers.push(marker);

      if (infoContent) {
        var infoWindow = new google.maps.InfoWindow({
          content: infoContent
        });

        var isOpen = true;

        infoWindow.open(_canvas, marker);

        marker.addListener("click", function () {
          if (isOpen) {
            infoWindow.close();
          } else {
            infoWindow.open(_canvas, marker);
          }
          isOpen = !isOpen;
        });
      }
    }
  }, {
    key: "clearMarkers",
    value: function clearMarkers() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_markers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var m = _step.value;

          m.setMap(null);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _markers = [];
    }
  }, {
    key: "fitToMarkers",
    value: function fitToMarkers() {
      if (_markers.length === 0) return;
      var bounds = new google.maps.LatLngBounds();
      _markers.forEach(function (marker) {
        return bounds.extend(marker.getPosition());
      });
      _canvas.fitBounds(bounds);
    }
  }, {
    key: "setCenter",
    value: function setCenter(_ref2) {
      var lat = _ref2.lat,
          lng = _ref2.lng;
      var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (_canvas) {
        var centerLatLng = new google.maps.LatLng(lat, lng);
        _canvas.setCenter(centerLatLng);

        if (zoom !== null) {
          _canvas.setZoom(zoom);
        }
      }
    }
  }, {
    key: "setZoom",
    value: function setZoom() {
      var zoom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (_canvas) {
        if (zoom !== null) {
          _canvas.setZoom(zoom);
        }
      }
    }
  }, {
    key: "isInRadius",
    get: function get() {
      var result = false;
      if (_circle !== undefined) {
        result = google.maps.geometry.spherical.computeDistanceBetween(_marker.getPosition(), _circle.getCenter()) <= _circle.getRadius();
        if (!result) {
          _marker.setVisible(false);
        }
      }
      return result;
    }
  }]);

  return MaverickMap;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickMap);

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapModal_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7861c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapModal_vue__ = __webpack_require__(561);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7861c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gmap-wrapper"},[(_vm.autocomplete)?_c('div',{staticClass:"pac-card",attrs:{"id":"pac-card"}},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"map"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pac-container"}},[_c('input',{attrs:{"id":"pac-input","type":"text","placeholder":"Enter a location"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/job/tenant";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAvailableCurrency: function getAvailableCurrency(reservationId) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/complete/" + reservationId)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  submitCompleteTrip: function submitCompleteTrip(reservationId, payload) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + ("/complete/" + reservationId), payload).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  countAll: function countAll(period, mode) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/count?period=" + period + "&mode=" + mode)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getAll: function getAll(filter) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/list" + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getDetail: function getDetail(reservationId) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/detail/" + reservationId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getPreferredProviders: function getPreferredProviders(reservationId) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/list/provider/" + reservationId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  manualDispatch: function manualDispatch(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/provider/dispatch/manual", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  releaseProvider: function releaseProvider(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/provider/release", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  abort: function abort(request) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/abort", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context9.abrupt("return", _context9.sent);

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  viewHistoryEvidence: function viewHistoryEvidence(id) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/history/attach/" + id)).then(function (response) {
                return response.data;
              });

            case 2:
              return _context10.abrupt("return", _context10.sent);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  confirmUnderReview: function confirmUnderReview(payload) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/confirm", payload).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context11.abrupt("return", _context11.sent);

            case 3:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  }
});

/***/ }),

/***/ 594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__(500);



var _this = this;



var _baseEndpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/job";

/* harmony default export */ __webpack_exports__["a"] = ({
  getTripLogging: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(reservationId, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/trip/" + reservationId + "/log", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function getTripLogging(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  createTripLog: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(reservationId, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].post(_baseEndpoint + "/trip/" + reservationId + "/log", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function createTripLog(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(),
  updateTripLog: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(reservationId, reservationHistoryId, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].put(_baseEndpoint + "/trip/" + reservationId + "/log/" + reservationHistoryId, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function updateTripLog(_x7, _x8, _x9, _x10) {
      return _ref3.apply(this, arguments);
    };
  }(),
  completeTrip: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(reservationId, payload, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].post(_baseEndpoint + "/trip/" + reservationId + "/complete", payload, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function completeTrip(_x11, _x12, _x13, _x14) {
      return _ref4.apply(this, arguments);
    };
  }(),
  backToRunStatus: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(reservationId, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].put(_baseEndpoint + "/trip/" + reservationId + "/set-as-run", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function backToRunStatus(_x15, _x16, _x17) {
      return _ref5.apply(this, arguments);
    };
  }(),
  uploadEvidencePaxNoShow: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(reservationId, payload, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].post(_baseEndpoint + "/trip/" + reservationId + "/pax-no-show/evidence", payload, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function uploadEvidencePaxNoShow(_x18, _x19, _x20, _x21) {
      return _ref6.apply(this, arguments);
    };
  }(),
  confirmPaxNoShow: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(reservationId, payload, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].post(_baseEndpoint + "/trip/" + reservationId + "/pax-no-show", payload, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));

    return function confirmPaxNoShow(_x22, _x23, _x24, _x25) {
      return _ref7.apply(this, arguments);
    };
  }(),
  getAttachment: function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(reservationId, query, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/trip/" + reservationId + "/attachment/link?path=" + query, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this);
    }));

    return function getAttachment(_x26, _x27, _x28, _x29) {
      return _ref8.apply(this, arguments);
    };
  }()
});

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__(500);



var _this = this;



var _baseEndpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/lookup";

/* harmony default export */ __webpack_exports__["a"] = ({
  availableEvent: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/trip-log/available-event", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function availableEvent(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(),
  chauffeurCommon: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/rental-type/chauffeur", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function chauffeurCommon(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(),
  selfdriveCommon: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/rental-type/self-drive", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function selfdriveCommon(_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }(),
  supportedCurrencies: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/supported-currencies", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function supportedCurrencies(_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }()
});

/***/ }),

/***/ 714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_MapModal__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_google_map_js__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_job_tripLogJob_tripLogJobService_js__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_job_tenantJob_inquiryTenantJobService_js__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_shop_lookup_lookupService_js__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_FormLogging__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_PaxNoShow__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_FormEditLogging__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_CompleteTripLog__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_numberHelper_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plugins_firebase_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_userHelper_js__ = __webpack_require__(531);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    mapModal: __WEBPACK_IMPORTED_MODULE_3__components_shared_MapModal__["a" /* default */],
    FormLogging: __WEBPACK_IMPORTED_MODULE_8__components_shared_FormLogging__["a" /* default */],
    FormEditLogging: __WEBPACK_IMPORTED_MODULE_10__components_shared_FormEditLogging__["a" /* default */],
    CompleteTripLog: __WEBPACK_IMPORTED_MODULE_11__components_shared_CompleteTripLog__["a" /* default */],
    PaxNoShow: __WEBPACK_IMPORTED_MODULE_9__components_shared_PaxNoShow__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      msg: "Please wait",
      adminNotes: null,
      moneyFormat: null,
      additionalNotes: null,
      map: null,
      userType: "Unspecified",
      allServices: null,
      isDifferentCurrency: false,
      reservation: {
        vehicle: {
          imageUri: ""
        }
      },
      eventData: [],
      supportedCurrency: [],
      waitingTimeData: null,
      driver: null,
      vehicle: null,
      durationInMinutes: 0
    };
  },

  computed: {
    isAllowViewAdminNotes: function isAllowViewAdminNotes() {
      return Object(__WEBPACK_IMPORTED_MODULE_15__helpers_userHelper_js__["d" /* allowToViewAdminNotes */])(this.allServices);
    },
    getHours: function getHours() {
      var minutes = this.durationInMinutes ? this.durationInMinutes : 0;
      return Object(__WEBPACK_IMPORTED_MODULE_13__helpers_numberHelper_js__["f" /* toHoursAndMinutes */])(minutes);
    },
    pickUpLocation: function pickUpLocation() {
      return this.reservation && this.reservation.pickUpLocation && this.reservation.pickUpLocation.name ? this.reservation.pickUpLocation.name : "";
    },
    pickUpLocationAddress: function pickUpLocationAddress() {
      return this.reservation && this.reservation.pickUpLocation && this.reservation.pickUpLocation.address ? this.reservation.pickUpLocation.address : "";
    },
    dropOffLocation: function dropOffLocation() {
      return this.reservation && this.reservation.dropOffLocation && this.reservation.dropOffLocation.name && this.reservation.dropOffLocation.name !== this.pickUpLocation ? this.reservation.dropOffLocation.name : "Same Location";
    },
    dropOffLocationAddress: function dropOffLocationAddress() {
      return this.reservation && this.reservation.dropOffLocation && this.reservation.dropOffLocation.name && this.reservation.dropOffLocation.name !== this.pickUpLocation ? this.reservation.dropOffLocation.address : "Same Location";
    },
    isAirportTransfer: function isAirportTransfer() {
      return this.reservation && this.reservation.serviceType && this.reservation.serviceType === "AirportTransfer";
    },
    isArrivedFlight: function isArrivedFlight() {
      return this.reservation && this.reservation.pickUpLocation && this.reservation.pickUpLocation.isAirportZone;
    },
    isDepartureFlight: function isDepartureFlight() {
      return this.reservation && this.reservation.dropOffLocation && this.reservation.dropOffLocation.isAirportZone;
    },
    hasPaxCapacity: function hasPaxCapacity() {
      return this.reservation && this.reservation.vehicle && this.reservation.vehicle.feature && this.reservation.vehicle.feature.paxCapacity && parseInt(this.reservation.vehicle.feature.paxCapacity) > 0;
    },
    hasLargeBaggageCapacity: function hasLargeBaggageCapacity() {
      return this.reservation && this.reservation.vehicle && this.reservation.vehicle.feature && this.reservation.vehicle.feature.largeBaggageCapacity && parseInt(this.reservation.vehicle.feature.largeBaggageCapacity) > 0;
    },
    hasSmallBaggageCapacity: function hasSmallBaggageCapacity() {
      return this.reservation && this.reservation.vehicle && this.reservation.vehicle.feature && this.reservation.vehicle.feature.smallBaggageCapacity && parseInt(this.reservation.vehicle.feature.smallBaggageCapacity) > 0;
    },
    showButtonNext: function showButtonNext() {
      return this.reservation.workflow && this.reservation.workflow.next && this.reservation.workflow.next.event !== 0;
    },
    showButtonCompleteTrip: function showButtonCompleteTrip() {
      return this.reservation.workflow.next && this.reservation.workflow.current.event === 18;
    },
    progressDone: function progressDone() {
      return this.reservation.jobStatusDescription === "Done";
    },
    fromTenant: function fromTenant() {
      return this.$route.path.includes("tenant");
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, userType, services;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.reservationLogging();

            case 3:
              _context.next = 5;
              return _this.$store.dispatch("user/getProfile");

            case 5:
              _ref = _context.sent;
              userType = _ref.userType;
              services = _ref.services;

              _this.userType = userType;
              _this.allServices = services;
              _context.next = 12;
              return _this.getEventAvailable();

            case 12:
              _context.next = 14;
              return _this.getDetailReservation();

            case 14:

              if (!_this.progressDone) {
                _this.getAvailableCurrency();
              }

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.state.setting.transactionCurrency = null;
  },
  mounted: function mounted() {
    if (!this.map) {
      // creates map instance
      this.map = new __WEBPACK_IMPORTED_MODULE_4__plugins_google_map_js__["a" /* default */]({
        mapId: "map",
        lat: -6.17003832454938,
        lng: 106.81490242481232,
        infoWindow: true
      });
      this.map.initialize();
    }
  },

  methods: {
    getAvailableCurrency: function getAvailableCurrency() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__services_job_tenantJob_inquiryTenantJobService_js__["a" /* default */].getAvailableCurrency(_this2.$route.params.id);

              case 2:
                response = _context2.sent;


                if (response.isSuccess) {
                  _this2.supportedCurrency = response.data;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getDetailReservation: function getDetailReservation() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var reservation, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__services_job_tenantJob_inquiryTenantJobService_js__["a" /* default */].getDetail(_this3.$route.params.id);

              case 3:
                reservation = _context3.sent;

                _this3.adminNotes = reservation.adminNotes;
                _this3.moneyFormat = reservation.moneyFormat;
                _this3.driver = reservation.driver;
                _this3.vehicle = reservation.vehicle;
                _this3.durationInMinutes = reservation.durationInMinutes;
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);

                if (_context3.t0.errors) {
                  for (index = 0; index < _context3.t0.errors.length; index++) {
                    _this3.$notification.error(_context3.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 11]]);
      }))();
    },
    reservationLogging: function reservationLogging() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isLoading = true;
                _context4.prev = 1;
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_job_tripLogJob_tripLogJobService_js__["a" /* default */].getTripLogging(_this4.$route.params.id);

              case 4:
                response = _context4.sent;


                if (response.isSuccess) {
                  _this4.reservation = response.data;
                }
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context4.prev = 11;

                _this4.isLoading = false;
                return _context4.finish(11);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 8, 11, 14]]);
      }))();
    },
    getEventAvailable: function getEventAvailable() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, data, dataArray, key, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__services_shop_lookup_lookupService_js__["a" /* default */].availableEvent();

              case 3:
                response = _context5.sent;
                data = response.data;
                dataArray = [];


                for (key in data) {
                  dataArray.push({ value: parseInt(key), label: data[key] });
                }

                _this5.eventData = dataArray;
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 10]]);
      }))();
    },
    handleCreateLog: function handleCreateLog() {
      this.$eventBus.$emit("FormLogging", this.eventData);
    },
    handleEditLog: function handleEditLog(data, pickUpDateTime) {
      this.$eventBus.$emit("FormEditLogging", data, pickUpDateTime, this.userType);
    },
    nextState: function nextState() {
      var numberUtc = this.reservation.pickUpDateTime.timezone.replace("UTC", "");

      var date = __WEBPACK_IMPORTED_MODULE_12_moment___default()().utcOffset("" + numberUtc);

      var payload = {
        event: this.reservation.workflow.next.event,
        date: date.format("YYYY-M-D"),
        time: date.format("H:m:s"),
        description: null
      };

      this.onSubmitLogging(payload);
    },
    onSubmitLogging: function onSubmitLogging(data) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var payload, response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.isLoading = true;
                _context6.prev = 1;

                // const dateSplit = data.date.split("-");
                // const timeSplit = data.time.split(":");
                payload = {
                  event: data.event,
                  // timestamp: {
                  //   year: Number(dateSplit[0]),
                  //   month: Number(dateSplit[1]),
                  //   day: Number(dateSplit[2]),
                  //   hour: Number(timeSplit[0]),
                  //   minute: Number(timeSplit[1]),
                  //   second: Number(timeSplit[2]),
                  // },
                  description: data.description
                };
                _context6.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__services_job_tripLogJob_tripLogJobService_js__["a" /* default */].createTripLog(_this6.$route.params.id, payload);

              case 5:
                response = _context6.sent;

                if (!response.isSuccess) {
                  _context6.next = 16;
                  break;
                }

                if (!response.data) {
                  _context6.next = 11;
                  break;
                }

                _this6.waitingTimeData = {
                  arrivalWaitingTime: response.data.arrivalWaitingTime,
                  allowedTime: response.data.allowedTime
                };
                _this6.openCompleteTrip();
                return _context6.abrupt("return");

              case 11:
                _this6.$notification.success("Successfully added new trip log.", {
                  title: "Success"
                });
                _this6.getEventAvailable();
                _context6.next = 15;
                return _this6.reservationLogging();

              case 15:
                _this6.updateReservationOnFirebase(_this6.reservation.reservationId, {
                  lastStateEnum: _this6.reservation.workflow.current.event
                });

              case 16:
                _context6.next = 21;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6["catch"](1);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this6.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 21:
                _context6.prev = 21;

                _this6.isLoading = false;
                return _context6.finish(21);

              case 24:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[1, 18, 21, 24]]);
      }))();
    },
    updateReservationOnFirebase: function updateReservationOnFirebase(reservationId, data) {
      __WEBPACK_IMPORTED_MODULE_14__plugins_firebase_js__["b" /* firebaseDB */].ref("locations/" + reservationId).once("value").then(function (snapshot) {
        if (snapshot.exists()) {
          __WEBPACK_IMPORTED_MODULE_14__plugins_firebase_js__["b" /* firebaseDB */].ref("locations/" + reservationId).update(data);
        }
      });
    },
    deleteReservationOnFirebase: function deleteReservationOnFirebase(reservationId) {
      __WEBPACK_IMPORTED_MODULE_14__plugins_firebase_js__["b" /* firebaseDB */].ref("locations/" + reservationId).remove();
    },
    onSubmitEditLogging: function onSubmitEditLogging(data) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var numberUtc, date, dateSplit, timeSplit, payload, response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.isLoading = true;
                _context7.prev = 1;
                numberUtc = _this7.reservation.pickUpDateTime.timezone.replace("UTC", "");
                date = __WEBPACK_IMPORTED_MODULE_12_moment___default()().utcOffset("" + numberUtc);
                dateSplit = data.date.split("-");
                timeSplit = data.time.split(":");
                payload = {
                  timestamp: {
                    year: Number(dateSplit[0]),
                    month: Number(dateSplit[1]),
                    day: Number(dateSplit[2]),
                    hour: Number(timeSplit[0]),
                    minute: Number(timeSplit[1]),
                    second: date.second()
                  },
                  description: data.description
                };
                _context7.next = 9;
                return __WEBPACK_IMPORTED_MODULE_5__services_job_tripLogJob_tripLogJobService_js__["a" /* default */].updateTripLog(_this7.$route.params.id, data.id, payload);

              case 9:
                response = _context7.sent;


                if (response.isSuccess) {
                  _this7.$notification.success("Successfully updated trip log.", {
                    title: "Success"
                  });
                }
                _context7.next = 17;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7["catch"](1);

                if (_context7.t0.errors) {
                  for (index = 0; index < _context7.t0.errors.length; index++) {
                    _this7.$notification.error(_context7.t0.errors[index], { title: "Error" });
                  }
                }
                _this7.isLoading = false;

              case 17:
                _context7.prev = 17;

                _this7.reservationLogging();
                _this7.getEventAvailable();
                return _context7.finish(17);

              case 21:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[1, 13, 17, 21]]);
      }))();
    },
    onClickOpenDetailLocation: function onClickOpenDetailLocation(detail) {
      this.map.showInfoWindow({
        latitude: detail.latitude,
        longitude: detail.longitude
      }, detail.address);
      $(this.$refs.mapmodal).modal();
    },
    openCompleteTrip: function openCompleteTrip() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.isLoading = true;

                _this8.$eventBus.$emit("completeTripLog", _this8.reservation, _this8.supportedCurrency, _this8.moneyFormat, _this8.waitingTimeData);

                _this8.isLoading = false;

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    onSubmitCompleteTrip: function onSubmitCompleteTrip(payload) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this9.isLoading = true;
                _context9.prev = 1;
                _context9.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_job_tripLogJob_tripLogJobService_js__["a" /* default */].completeTrip(_this9.$route.params.id, payload);

              case 4:
                response = _context9.sent;


                if (response.isSuccess) {
                  _this9.$notification.success("Job succesfully marked as completed.", {
                    title: "Success"
                  });
                  _this9.deleteReservationOnFirebase(_this9.reservation.reservationId);
                }
                _context9.next = 11;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](1);

                for (index = 0; index < _context9.t0.errors.length; index++) {
                  _this9.$notification.error(_context9.t0.errors[index], { title: "Error" });
                }

              case 11:
                _context9.prev = 11;

                _this9.reservationLogging();
                _this9.isLoading = false;
                return _context9.finish(11);

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[1, 8, 11, 15]]);
      }))();
    },

    showEditable: function showEditable(value) {
      return value === "Driver enroute to pick-up location" || value === "Driver on site" || value === "Passenger onboard" || value === "Trip started" || value === "Passenger dropped off" || value === "Passenger no show / cancelled" || value === "Driver enroute";
    },
    openModalPaxNoShow: function openModalPaxNoShow() {
      var data = {
        uuid: this.uuidv4(),
        reservationId: this.$route.params.id
      };
      this.$eventBus.$emit("PaxNoShow", data);
    },
    confirmPaxNoShow: function confirmPaxNoShow(payload) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this10.isLoading = true;
                _context10.prev = 1;
                _context10.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__services_job_tripLogJob_tripLogJobService_js__["a" /* default */].confirmPaxNoShow(_this10.$route.params.id, payload);

              case 4:
                response = _context10.sent;


                if (response.isSuccess) {
                  _this10.waitingTimeData = response.data ? {
                    arrivalWaitingTime: response.data.waitingTime,
                    allowedTime: response.data.totalMinuteAllowed
                  } : null;
                }

                _this10.openCompleteTrip();
                _context10.next = 12;
                break;

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10["catch"](1);

                for (index = 0; index < _context10.t0.errors.length; index++) {
                  _this10.$notification.error(_context10.t0.errors[index], { title: "Error" });
                }

              case 12:
                _context10.prev = 12;

                _this10.isLoading = false;
                return _context10.finish(12);

              case 15:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[1, 9, 12, 15]]);
      }))();
    },
    uuidv4: function uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  },
  watch: {
    reservation: {
      deep: true,
      handler: function handler(value) {
        if (value.workflow.next === null) {
          this.deleteReservationOnFirebase(this.reservation.reservationId);
        }
      }
    }
  }
});

/***/ }),

/***/ 715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isOpen: false,
      isLoading: false,
      msg: "Please wait",
      isSubmitted: false,
      form: {
        event: "",
        date: "",
        time: "",
        description: ""
      },
      eventData: []
    };
  },
  validations: function validations() {
    var v = {
      form: {
        event: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
        date: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
        time: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] },
        description: { required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"] }
      }
    };

    return v;
  },
  created: function created() {
    this.$eventBus.$on("FormLogging", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("FormLogging");
  },

  methods: {
    initialize: function initialize(eventData) {
      var _this = this;

      this.isLoading = true;
      this.isOpen = true;
      this.eventData = eventData;
      this.form = {
        event: "",
        date: "",
        time: "",
        description: ""
      };
      setTimeout(function () {
        $(_this.$refs.extraModal).modal({
          backdrop: "static",
          keyboard: false
        });
        _this.isLoading = false;
      }, 1000);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.isSubmitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.$nextTick(function () {
          return _this2.$helper.focusToFieldError();
        });
        return;
      }
      this.$emit("submit", this.form);
      this.closeModal();
    },
    closeModal: function closeModal() {
      this.isOpen = false;
      this.isSubmitted = false;
      $(this.$refs.extraModal).modal("hide");
    }
  },
  updated: function updated() {
    this.$helper.numbersOnly();
  }
});

/***/ }),

/***/ 716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_job_tripLogJob_tripLogJobService_js__ = __webpack_require__(594);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isOpen: false,
      isLoading: false,
      msg: "Please wait",
      reservationId: null,
      limitEvidence: 0,
      evidenceContactPaxList: [],
      previewContactPax: null,
      previewVehicle: null,
      evidenceVehicleList: [],
      data: {
        id: "",
        notes: "",
        evidences: {
          attemptToContactPax: [],
          vehicleOnLocation: []
        }
      }
    };
  },

  computed: {
    enabledConfirmBtn: function enabledConfirmBtn() {
      return this.evidenceContactPaxList.length >= 1 && this.evidenceVehicleList.length >= 1 && this.data.notes;
    }
  },
  created: function created() {
    this.$eventBus.$on("PaxNoShow", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("PaxNoShow");
  },

  methods: {
    setPreviewContactImage: function setPreviewContactImage(item, type) {
      if (type === 1) {
        this.previewContactPax = item;
      } else {
        this.previewVehicle = item;
      }
    },
    initialize: function initialize(payload) {
      var _this = this;

      this.isOpen = true;
      this.isLoading = true;

      this.data = {
        notes: "",
        evidences: {
          attemptToContactPax: [],
          vehicleOnLocation: []
        },
        id: payload.uuid
      };
      this.evidenceContactPaxList = [];
      this.evidenceVehicleList = [];
      this.reservationId = payload.reservationId;

      setTimeout(function () {
        $(_this.$refs.extraModal).modal({
          backdrop: "static",
          keyboard: false
        });
        _this.isLoading = false;
      }, 500);
    },
    deleteImagePreview: function deleteImagePreview(id, type) {
      if (type === 1) {
        this.data.evidences.attemptToContactPax = this.data.evidences.attemptToContactPax.filter(function (val) {
          return val !== id;
        });
        this.evidenceContactPaxList = this.evidenceContactPaxList.filter(function (val) {
          return val.id !== id;
        });
      } else {
        this.data.evidences.vehicleOnLocation = this.data.evidences.vehicleOnLocation.filter(function (val) {
          return val !== id;
        });
        this.evidenceVehicleList = this.evidenceVehicleList.filter(function (val) {
          return val.id !== id;
        });
      }
    },
    uploadEvidence: function uploadEvidence(files, type) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var limit, _limit, index, formData, response, _index;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // for (const file of files) {
                //   if (file.type === "application/pdf") {
                //     console.error(`File ${file.name} tidak boleh PDF!`);
                //     alert(`Upload gagal: ${file.name} bertipe PDF`);
                //     return;
                //   }
                // }

                _this2.isLoading = true;
                _context.prev = 1;

                if (type === 1) {
                  limit = 5 - _this2.evidenceContactPaxList.length;

                  _this2.limitEvidence = _this2.evidenceContactPaxList.length === 0 && files.length >= 5 ? 5 : _this2.evidenceContactPaxList.length === 0 && files.length < 5 ? files.length : files.length > limit ? limit : files.length;
                } else {
                  _limit = 5 - _this2.evidenceVehicleList.length;

                  _this2.limitEvidence = _this2.evidenceVehicleList.length === 0 && files.length >= 5 ? 5 : _this2.evidenceContactPaxList.length === 0 && files.length < 5 ? files.length : files.length > _limit ? _limit : files.length;
                }

                index = 0;

              case 4:
                if (!(index < _this2.limitEvidence)) {
                  _context.next = 20;
                  break;
                }

                if (!(files[index].type === "application/pdf")) {
                  _context.next = 9;
                  break;
                }

                _this2.$notification.error("Can't upload pdf file (" + files[index].name + ")", { title: "Error" });
                _context.next = 17;
                break;

              case 9:
                formData = new FormData();

                formData.append("refferalId", _this2.data.id);
                formData.append("category", type);
                formData.append("file", files[index]);

                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_2__services_job_tripLogJob_tripLogJobService_js__["a" /* default */].uploadEvidencePaxNoShow(_this2.reservationId, formData);

              case 15:
                response = _context.sent;


                if (response.isSuccess) {
                  if (type === 1) {
                    _this2.data.evidences.attemptToContactPax.push(response.data);
                    _this2.evidenceContactPaxList.push({
                      imagePreview: URL.createObjectURL(files[index]),
                      id: response.data
                    });
                    _this2.previewContactPax = {
                      imagePreview: URL.createObjectURL(files[index]),
                      id: response.data
                    };
                  } else {
                    _this2.data.evidences.vehicleOnLocation.push(response.data);
                    _this2.evidenceVehicleList.push({
                      imagePreview: URL.createObjectURL(files[index]),
                      id: response.data
                    });
                    _this2.previewVehicle = {
                      imagePreview: URL.createObjectURL(files[index]),
                      id: response.data
                    };
                  }
                }

              case 17:
                index++;
                _context.next = 4;
                break;

              case 20:
                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](1);

                if (_context.t0.errors) {
                  for (_index = 0; _index < _context.t0.errors.length; _index++) {
                    _this2.$notification.error(_context.t0.errors[_index], { title: "Error" });
                  }
                }

              case 25:
                _context.prev = 25;

                _this2.isLoading = false;
                return _context.finish(25);

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 22, 25, 28]]);
      }))();
    },
    confirmPaxNoShow: function confirmPaxNoShow() {
      this.$emit("confirm", this.data);
      this.isOpen = false;
      $(this.$refs.extraModal).modal("hide");
    }
  }
});

/***/ }),

/***/ 717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isOpen: false,
      isLoading: false,
      msg: "Please wait",
      isSubmitted: false,
      form: {
        id: "",
        date: "",
        time: "",
        description: ""
      },
      timeZone: "",
      disabledDates: null
    };
  },
  validations: function validations() {
    var v = {
      form: {
        id: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
        date: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
        time: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
        description: {}
      }
    };

    return v;
  },
  created: function created() {
    this.$eventBus.$on("FormEditLogging", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("FormEditLogging");
  },

  methods: {
    initialize: function initialize(data, pickUpDateTime, userType) {
      var _this = this;

      this.isLoading = true;
      this.isOpen = true;

      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(pickUpDateTime.dateTime);

      if (userType === "TenantUser") {
        var disabledDates = date.subtract(1, "days");
        this.disabledDates = disabledDates.format("YYYY-MM-DD");
      } else {
        this.disabledDates = date.format("YYYY-MM-DD");
      }

      this.timeZone = data.timeStamp.timezone;

      // let utc;
      // if (this.timeZone.includes("+")) {
      //   utc = `+${this.timeZone.split("+")[1]}`;
      // }

      // if (this.timeZone.includes("-")) {
      //   utc = `+${this.timeZone.split("-")[1]}`;
      // }

      var originalDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.timeStamp.dateTime);
      // const adjustedDate = originalDate.utcOffset(utc);

      // const formattedDate = adjustedDate.format("YYYY-MM-DD");
      // const formattedTime = adjustedDate.format("HH:mm");

      var formattedDate = originalDate.parseZone().format("YYYY-MM-DD");
      var formattedTime = originalDate.parseZone().format("HH:mm");

      this.form = {
        id: data.id,
        date: formattedDate,
        time: formattedTime,
        description: data.description
      };
      setTimeout(function () {
        $(_this.$refs.extraModal).modal({
          backdrop: "static",
          keyboard: false
        });
        _this.isLoading = false;
      }, 1000);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.isSubmitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.$nextTick(function () {
          return _this2.$helper.focusToFieldError();
        });
        return;
      }
      this.$emit("submit", this.form);
      this.closeModal();
    },
    closeModal: function closeModal() {
      this.isOpen = false;
      this.isSubmitted = false;
      $(this.$refs.extraModal).modal("hide");
    }
  },
  updated: function updated() {
    this.$helper.numbersOnly();
  }
});

/***/ }),

/***/ 718:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: null,
      moneyFormat: null,
      isOpen: false,
      isLoading: false,
      msg: "Please wait",
      currencyOptions: [],
      model: [{
        id: this.$helper.emptyGuid(),
        masterClassAncillaryId: this.$helper.emptyGuid(),
        name: "Parking Fare",
        fareComponentType: "ParkingFare",
        quantity: 1,
        currency: null,
        rate: null,
        attachment: null,
        imagePreview: null,
        active: false
      }, {
        id: this.$helper.emptyGuid(),
        masterClassAncillaryId: this.$helper.emptyGuid(),
        name: "Toll Fare",
        fareComponentType: "TollFare",
        quantity: 1,
        currency: null,
        rate: null,
        attachment: null,
        imagePreview: null,
        active: false
      }, {
        id: this.$helper.emptyGuid(),
        masterClassAncillaryId: this.$helper.emptyGuid(),
        name: "Arrival Waiting Time",
        fareComponentType: "ArrivalWaitingTime",
        quantity: 0,
        currency: null,
        rate: 0,
        attachment: null,
        imagePreview: null,
        active: false
      }],
      showWaitingTime: false,
      allowedTime: 0
    };
  },

  computed: {
    disabledBtnComplete: function disabledBtnComplete() {
      if (this.model[0].active && this.model[1].active) {
        return !this.model[0].rate && !this.model[1].rate;
      } else if (this.model[0].active) {
        return !this.model[0].rate;
      } else if (this.model[1].active) {
        return !this.model[0].rate;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    this.$eventBus.$on("completeTripLog", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("completeTripLog");
  },

  methods: {
    initialize: function initialize(data, currency, moneyFormat) {
      var _this = this;

      var waitingTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      this.isLoading = true;
      this.isOpen = true;
      this.data = data;
      this.moneyFormat = moneyFormat;
      this.currencyOptions = currency.map(function (val) {
        return {
          label: val,
          value: val
        };
      });
      this.model[0].currency = currency[0];
      this.model[1].currency = currency[0];
      this.model[2].currency = currency[0];
      if (waitingTime) {
        this.model[2].quantity = waitingTime.arrivalWaitingTime > 99 ? 99 : Math.round(waitingTime.arrivalWaitingTime);
        this.allowedTime = Math.round(waitingTime.allowedTime);
      }
      this.showWaitingTime = waitingTime ? true : false;
      setTimeout(function () {
        $(_this.$refs.vue_modal_complete_trip_log).modal({
          backdrop: "static",
          keyboard: false
        });
        _this.isLoading = false;
      }, 300);
    },
    onCloseModal: function onCloseModal() {
      this.data = null;
      this.currencyOptions = [];
      this.model = [{
        id: this.$helper.emptyGuid(),
        masterClassAncillaryId: this.$helper.emptyGuid(),
        name: "Parking Fare",
        fareComponentType: "ParkingFare",
        quantity: 1,
        currency: null,
        rate: null,
        attachment: null,
        imagePreview: null,
        active: false
      }, {
        id: this.$helper.emptyGuid(),
        masterClassAncillaryId: this.$helper.emptyGuid(),
        name: "Toll Fare",
        fareComponentType: "TollFare",
        quantity: 1,
        currency: null,
        rate: null,
        attachment: null,
        imagePreview: null,
        active: false
      }, {
        id: this.$helper.emptyGuid(),
        masterClassAncillaryId: this.$helper.emptyGuid(),
        name: "Arrival Waiting Time",
        fareComponentType: "ArrivalWaitingTime",
        quantity: 0,
        currency: null,
        rate: null,
        attachment: null,
        imagePreview: null,
        active: false
      }];
      this.isOpen = false;
      $(this.$refs.vue_modal_complete_trip_log).modal("hide");
    },
    onChangeImage: function onChangeImage(files, key) {
      var maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.model[0].imagePreview = null;
        this.model[1].imagePreview = null;
        this.model[0].attachment = null;
        this.model[1].attachment = null;
        document.getElementById("image-uploader").value = "";
        alert("File is too big, max-size is  " + parseInt(maxSize / 1000000) + "MB.");
        return;
      }
      if (!["jpeg", "jpg", "png"].includes(files[0].name.substring(files[0].name.lastIndexOf(".") + 1).toLowerCase())) {
        this.model[0].imagePreview = null;
        this.model[1].imagePreview = null;
        this.model[0].attachment = null;
        this.model[1].attachment = null;
        document.getElementById("image-uploader").value = "";
        alert("Invalid file type.");
        return;
      }

      if (key === "parking") {
        this.model[0].imagePreview = URL.createObjectURL(files[0]);
        this.model[0].attachment = files[0];
      } else {
        this.model[1].imagePreview = URL.createObjectURL(files[0]);
        this.model[1].attachment = files[0];
      }
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var ancillaries, payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                ancillaries = _this2.model.filter(function (val) {
                  return val.active === true;
                });
                payload = {
                  ancillaries: ancillaries,
                  waitingTimes: []
                };


                _this2.$emit("finish", payload);

                _this2.onCloseModal();
                _this2.loading = false;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleKeyUpQuantity: function handleKeyUpQuantity(value) {
      if (Number(value) > 99) {
        this.model[2].quantity = 99;
      }
    },
    handleBlurQuantity: function handleBlurQuantity(value) {
      if (!value || Number(value) === 0) {
        this.model[2].quantity = 1;
      }
    }
  },
  updated: function updated() {
    this.$helper.numbersOnly();
  }
});

/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(862);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("24bdc27c", content, true, {});

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".indicator-repriced[data-v-2fa0b572]{color:#d3d300;font-size:20px;font-weight:700;top:-10px}.vue-stars label[data-v-2fa0b572]{font-size:25px}.other-action[data-v-2fa0b572]:hover,.payment-method[data-v-2fa0b572]:hover{cursor:pointer}.payment-wrapper[data-v-2fa0b572]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:20px 20px 5px;border-top:1px solid #ddd;margin-top:13px}.payment-wrapper div.dropdown-submitted[data-v-2fa0b572],.payment-wrapper div.dropdown[data-v-2fa0b572]{width:80%}.payment-wrapper div.dropdown.more-dropdown[data-v-2fa0b572]{width:13%}.payment-wrapper button.btn-default[data-v-2fa0b572],.payment-wrapper button.btn-primary[data-v-2fa0b572]{width:100%;height:42px;text-transform:uppercase;font-weight:900;-webkit-box-shadow:0 4px 8px -5px #4c4c4c;box-shadow:0 4px 8px -5px #4c4c4c}.payment-wrapper button.btn-paymentsubmit[data-v-2fa0b572]{background:#4fb848}.payment-wrapper button.btn-aborted[data-v-2fa0b572],.payment-wrapper button.btn-paymentsubmit[data-v-2fa0b572]{width:100%;height:42px;text-transform:uppercase;font-weight:900;-webkit-box-shadow:0 4px 8px -5px #4c4c4c;box-shadow:0 4px 8px -5px #4c4c4c;cursor:auto}.payment-wrapper button.btn-aborted[data-v-2fa0b572]{background:#eb0011}.payment-wrapper button.btn-default[data-v-2fa0b572]{background:#eaeaea}.info-wrapper[data-v-2fa0b572]{margin-top:20px;font-size:.9333rem}.dropdown-menu>li a a[data-v-2fa0b572]{color:#666!important}.stamp-status button[data-v-2fa0b572]{background:transparent;border:none;border-radius:5px;color:#009688!important}.stamp-status button svg[data-v-2fa0b572]{width:18px}.panel-body .trip-button-wrapper[data-v-2fa0b572]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:20px;width:100%;margin-top:10px}.btn-back-log[data-v-2fa0b572]{color:#4fb848;background:#fff;width:50%;border:1px solid #4fb848}.btn-complete-trip[data-v-2fa0b572],.btn-next[data-v-2fa0b572],.btn-no-show[data-v-2fa0b572]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:15px;background:#4fb848;color:#fff;width:100%;text-transform:uppercase;font-weight:700}.btn-no-show[data-v-2fa0b572]{background:#eb0011}.btn-complete-trip svg[data-v-2fa0b572],.btn-next svg[data-v-2fa0b572]{width:25px}.button-wrapper-log[data-v-2fa0b572]{border:1px solid #ddd;padding:10px 20px;margin-top:45px;border-radius:10px}", "", {"version":3,"sources":["/app/src/components/reservation/inquiry/ReservationLogging.vue"],"names":[],"mappings":"AACA,qCACE,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,SAAW,CACZ,AACD,kCACE,cAAgB,CACjB,AACD,4EAEE,cAAgB,CACjB,AACD,kCACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,sBAA4B,AAC5B,0BAA2B,AAC3B,eAAiB,CAClB,AAID,wGACE,SAAW,CACZ,AACD,6DACE,SAAW,CACZ,AACD,0GAEE,WAAY,AACZ,YAAa,AACb,yBAA0B,AAC1B,gBAAiB,AACjB,0CAA6C,AAC7C,iCAAqC,CACtC,AACD,2DAIE,kBAAoB,CAKrB,AACD,gHATE,WAAY,AACZ,YAAa,AACb,yBAA0B,AAE1B,gBAAiB,AACjB,0CAA6C,AAC7C,kCAAqC,AACrC,WAAa,CAWd,AATD,qDAIE,kBAAoB,CAKrB,AACD,qDACE,kBAA+B,CAChC,AACD,+BACE,gBAAiB,AACjB,kBAAqB,CACtB,AACD,uCACE,oBAAuB,CACxB,AACD,sCACE,uBAAwB,AACxB,YAAa,AACb,kBAAmB,AACnB,uBAA0B,CAC3B,AACD,0CACE,UAAY,CACb,AACD,kDACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,WAAY,AACZ,eAAiB,CAClB,AACD,+BACE,cAAe,AACf,gBAAiB,AACjB,UAAW,AACX,wBAA0B,CAC3B,AACD,6FAGE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,mBAAoB,AACpB,WAAY,AACZ,WAAY,AACZ,yBAA0B,AAC1B,eAAiB,CAClB,AACD,8BACE,kBAAoB,CACrB,AACD,uEAEE,UAAY,CACb,AACD,qCACE,sBAAuB,AACvB,kBAAmB,AACnB,gBAAiB,AACjB,kBAAoB,CACrB","file":"ReservationLogging.vue","sourcesContent":["\n.indicator-repriced[data-v-2fa0b572] {\n  color: #d3d300;\n  font-size: 20px;\n  font-weight: 700;\n  top: -10px;\n}\n.vue-stars label[data-v-2fa0b572] {\n  font-size: 25px;\n}\n.payment-method[data-v-2fa0b572]:hover,\n.other-action[data-v-2fa0b572]:hover {\n  cursor: pointer;\n}\n.payment-wrapper[data-v-2fa0b572] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 20px 20px 5px 20px;\n  border-top: 1px solid #ddd;\n  margin-top: 13px;\n}\n.payment-wrapper div.dropdown[data-v-2fa0b572] {\n  width: 80%;\n}\n.payment-wrapper div.dropdown-submitted[data-v-2fa0b572] {\n  width: 80%;\n}\n.payment-wrapper div.dropdown.more-dropdown[data-v-2fa0b572] {\n  width: 13%;\n}\n.payment-wrapper button.btn-primary[data-v-2fa0b572],\n.payment-wrapper button.btn-default[data-v-2fa0b572] {\n  width: 100%;\n  height: 42px;\n  text-transform: uppercase;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 4px 8px -5px #4c4c4c;\n  box-shadow: 0px 4px 8px -5px #4c4c4c;\n}\n.payment-wrapper button.btn-paymentsubmit[data-v-2fa0b572] {\n  width: 100%;\n  height: 42px;\n  text-transform: uppercase;\n  background: #4fb848;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 4px 8px -5px #4c4c4c;\n  box-shadow: 0px 4px 8px -5px #4c4c4c;\n  cursor: auto;\n}\n.payment-wrapper button.btn-aborted[data-v-2fa0b572] {\n  width: 100%;\n  height: 42px;\n  text-transform: uppercase;\n  background: #eb0011;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 4px 8px -5px #4c4c4c;\n  box-shadow: 0px 4px 8px -5px #4c4c4c;\n  cursor: auto;\n}\n.payment-wrapper button.btn-default[data-v-2fa0b572] {\n  background: rgb(234, 234, 234);\n}\n.info-wrapper[data-v-2fa0b572] {\n  margin-top: 20px;\n  font-size: 0.9333rem;\n}\n.dropdown-menu > li a a[data-v-2fa0b572] {\n  color: #666 !important;\n}\n.stamp-status button[data-v-2fa0b572] {\n  background: transparent;\n  border: none;\n  border-radius: 5px;\n  color: #009688 !important;\n}\n.stamp-status button svg[data-v-2fa0b572] {\n  width: 18px;\n}\n.panel-body .trip-button-wrapper[data-v-2fa0b572] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 20px;\n  width: 100%;\n  margin-top: 10px;\n}\n.btn-back-log[data-v-2fa0b572] {\n  color: #4fb848;\n  background: #fff;\n  width: 50%;\n  border: 1px solid #4fb848;\n}\n.btn-next[data-v-2fa0b572],\n.btn-complete-trip[data-v-2fa0b572],\n.btn-no-show[data-v-2fa0b572] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 15px;\n  background: #4fb848;\n  color: #fff;\n  width: 100%;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n.btn-no-show[data-v-2fa0b572] {\n  background: #eb0011;\n}\n.btn-next svg[data-v-2fa0b572],\n.btn-complete-trip svg[data-v-2fa0b572] {\n  width: 25px;\n}\n.button-wrapper-log[data-v-2fa0b572] {\n  border: 1px solid #ddd;\n  padding: 10px 20px;\n  margin-top: 45px;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormLogging_vue__ = __webpack_require__(715);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b71cd3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormLogging_vue__ = __webpack_require__(866);
function injectStyle (ssrContext) {
  __webpack_require__(864)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47b71cd3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormLogging_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b71cd3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormLogging_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(865);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("3253ac04", content, true, {});

/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".modal-body.repricing-modal[data-v-47b71cd3]{padding:15px 20px}.btn.btn-submit[data-v-47b71cd3]{background:#4fb848}.btn.btn-cancel[data-v-47b71cd3],.btn.btn-submit[data-v-47b71cd3]{font-size:.8667rem;border-radius:5px;border:transparent;font-weight:900;-webkit-box-shadow:0 2px 8px -5px #4c4c4c;box-shadow:0 2px 8px -5px #4c4c4c;color:#fff;padding:10px 20px;text-transform:uppercase;outline:none}.btn.btn-cancel[data-v-47b71cd3]{background:#a0a0a0}.btn.btn-submit[data-v-47b71cd3]:hover{background:#339c2b}.btn.btn-cancel[data-v-47b71cd3]:hover{background:#888}.gap-10[data-v-47b71cd3]{gap:10px}", "", {"version":3,"sources":["/app/src/components/shared/FormLogging.vue"],"names":[],"mappings":"AACA,6CACE,iBAAmB,CACpB,AACD,iCACE,kBAAoB,CAWrB,AACD,kEAXE,mBAAqB,AACrB,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,0CAA6C,AAC7C,kCAAqC,AACrC,WAAY,AACZ,kBAAmB,AACnB,yBAA0B,AAC1B,YAAc,CAcf,AAZD,iCACE,kBAAoB,CAWrB,AACD,uCACE,kBAAoB,CACrB,AACD,uCACE,eAAoB,CACrB,AACD,yBACE,QAAU,CACX","file":"FormLogging.vue","sourcesContent":["\n.modal-body.repricing-modal[data-v-47b71cd3] {\n  padding: 15px 20px;\n}\n.btn.btn-submit[data-v-47b71cd3] {\n  background: #4fb848;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-cancel[data-v-47b71cd3] {\n  background: #a0a0a0;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-submit[data-v-47b71cd3]:hover {\n  background: #339c2b;\n}\n.btn.btn-cancel[data-v-47b71cd3]:hover {\n  background: #888888;\n}\n.gap-10[data-v-47b71cd3] {\n  gap: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',[_c('div',{ref:"extraModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-md"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body repricing-modal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-between items-center"},[_c('h4',{staticStyle:{"font-weight":"800"}},[_vm._v("Create Trip Log")]),_vm._v(" "),_c('button',{staticClass:"close btn-close-modal",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('form',{staticStyle:{"margin-top":"20px"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Event Name")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","options":_vm.eventData,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.form.event),callback:function ($$v) {_vm.$set(_vm.form, "event", $$v)},expression:"form.event"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Date")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"label":"Select date","id":"date","color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD, YYYY","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Time")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"label":"Select time","id":"time","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","only-time":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.form.time),callback:function ($$v) {_vm.$set(_vm.form, "time", $$v)},expression:"form.time"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"name":"description","id":"description","cols":"30","rows":"10"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})])]),_vm._v(" "),_vm._m(0)])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-end gap-10 items-center"},[_c('button',{staticClass:"btn btn-cancel",attrs:{"type":"reset"}},[_vm._v("Reset")]),_vm._v(" "),_c('button',{staticClass:"btn btn-submit",attrs:{"type":"submit"}},[_vm._v("\n                      Submit\n                    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaxNoShow_vue__ = __webpack_require__(716);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4226ba22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaxNoShow_vue__ = __webpack_require__(870);
function injectStyle (ssrContext) {
  __webpack_require__(868)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4226ba22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaxNoShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4226ba22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaxNoShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(869);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("2969e0c0", content, true, {});

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".modal-body.repricing-modal[data-v-4226ba22]{padding:15px 20px}.btn.btn-submit[data-v-4226ba22]{background:#4fb848}.btn.btn-cancel[data-v-4226ba22],.btn.btn-submit[data-v-4226ba22]{font-size:.8667rem;border-radius:5px;border:transparent;font-weight:900;-webkit-box-shadow:0 2px 8px -5px #4c4c4c;box-shadow:0 2px 8px -5px #4c4c4c;color:#fff;padding:10px 20px;text-transform:uppercase;outline:none}.btn.btn-cancel[data-v-4226ba22]{background:#a0a0a0}.btn.btn-submit[data-v-4226ba22]:hover{background:#339c2b}.btn.btn-cancel[data-v-4226ba22]:hover{background:#888}.gap-10[data-v-4226ba22]{gap:10px}.confirm-btn-wrapper[data-v-4226ba22],.description-wrapper[data-v-4226ba22],.evidence-vehicle-wrapper[data-v-4226ba22]{margin-top:40px}h4.title-evidence[data-v-4226ba22]{font-weight:700}p.subtitile-evidence[data-v-4226ba22]{font-size:14px;font-weight:300;line-height:16.8px}.input-file[data-v-4226ba22]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#edf6ec;width:100%;height:160px;border-radius:6px;cursor:pointer}.input-file .preview-active[data-v-4226ba22]{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.input-std[data-v-4226ba22]{font-size:18px;font-weight:700;line-height:21.6px}#input-evidence-contact[data-v-4226ba22],#input-evidence-vehicle[data-v-4226ba22]{display:none}.img-review-wrapper[data-v-4226ba22]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%;gap:10px}.img-review-wrapper>.img-item[data-v-4226ba22]{position:relative;width:55px;height:60px;background:#edf6ec;border-radius:6px;overflow:hidden;border:.5px solid #a0a0a0}.img-review-wrapper>.img-item.active[data-v-4226ba22]{border:2px solid #d2f5ce}.img-review-wrapper>.img-item>img[data-v-4226ba22]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.img-review-wrapper>.img-item.upload-images[data-v-4226ba22]{background:#edf6ec;color:#000;font-size:30px;font-weight:700;border:none;cursor:pointer}.img-review-wrapper>.img-item.upload-images[data-v-4226ba22],button.btn-delete-img[data-v-4226ba22]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}button.btn-delete-img[data-v-4226ba22]{position:absolute;font-size:10px;top:0;right:0;height:18px;width:18px;border-radius:50%;background:#676666;color:#fff}button.btn-delete-img[data-v-4226ba22]:hover{background:#373737}.max-img-notes[data-v-4226ba22]{width:100%;font-size:14px;font-weight:300;line-height:16.8px;font-style:italic}.max-img-notes[data-v-4226ba22]:before{content:\"* \"}", "", {"version":3,"sources":["/app/src/components/shared/PaxNoShow.vue"],"names":[],"mappings":"AACA,6CACE,iBAAmB,CACpB,AACD,iCACE,kBAAoB,CAWrB,AACD,kEAXE,mBAAqB,AACrB,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,0CAA6C,AAC7C,kCAAqC,AACrC,WAAY,AACZ,kBAAmB,AACnB,yBAA0B,AAC1B,YAAc,CAcf,AAZD,iCACE,kBAAoB,CAWrB,AACD,uCACE,kBAAoB,CACrB,AACD,uCACE,eAAoB,CACrB,AACD,yBACE,QAAU,CACX,AACD,uHAGE,eAAiB,CAClB,AACD,mCACE,eAAiB,CAClB,AACD,sCACE,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,6BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,mBAAoB,AACpB,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,cAAgB,CACjB,AACD,6CACE,WAAY,AACZ,YAAa,AACb,sBAAuB,AACpB,kBAAoB,CACxB,AACD,4BACE,eAAgB,AAChB,gBAAiB,AACjB,kBAAoB,CACrB,AACD,kFAEE,YAAc,CACf,AACD,qCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,WAAY,AACZ,QAAU,CACX,AACD,+CACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,yBAAuC,CACxC,AACD,sDACE,wBAA0B,CAC3B,AACD,mDACE,WAAY,AACZ,YAAa,AACb,oBAAqB,AAClB,gBAAkB,CACtB,AACD,6DAUE,mBAAoB,AACpB,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,cAAgB,CACjB,AACD,oGAhBE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CA2B7B,AAnBD,uCAUE,kBAAmB,AACnB,eAAgB,AAChB,MAAO,AACP,QAAS,AACT,YAAa,AACb,WAAY,AACZ,kBAAmB,AACnB,mBAAoB,AACpB,UAAY,CACb,AACD,6CACE,kBAAoB,CACrB,AACD,gCACE,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,iBAAmB,CACpB,AACD,uCACE,YAAc,CACf","file":"PaxNoShow.vue","sourcesContent":["\n.modal-body.repricing-modal[data-v-4226ba22] {\n  padding: 15px 20px;\n}\n.btn.btn-submit[data-v-4226ba22] {\n  background: #4fb848;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-cancel[data-v-4226ba22] {\n  background: #a0a0a0;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-submit[data-v-4226ba22]:hover {\n  background: #339c2b;\n}\n.btn.btn-cancel[data-v-4226ba22]:hover {\n  background: #888888;\n}\n.gap-10[data-v-4226ba22] {\n  gap: 10px;\n}\n.evidence-vehicle-wrapper[data-v-4226ba22],\n.description-wrapper[data-v-4226ba22],\n.confirm-btn-wrapper[data-v-4226ba22] {\n  margin-top: 40px;\n}\nh4.title-evidence[data-v-4226ba22] {\n  font-weight: 700;\n}\np.subtitile-evidence[data-v-4226ba22] {\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 16.8px;\n}\n.input-file[data-v-4226ba22] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: #edf6ec;\n  width: 100%;\n  height: 160px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.input-file .preview-active[data-v-4226ba22] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.input-std[data-v-4226ba22] {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 21.6px;\n}\n#input-evidence-contact[data-v-4226ba22],\n#input-evidence-vehicle[data-v-4226ba22] {\n  display: none;\n}\n.img-review-wrapper[data-v-4226ba22] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  width: 100%;\n  gap: 10px;\n}\n.img-review-wrapper > .img-item[data-v-4226ba22] {\n  position: relative;\n  width: 55px;\n  height: 60px;\n  background: #edf6ec;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 0.5px solid rgb(160, 160, 160);\n}\n.img-review-wrapper > .img-item.active[data-v-4226ba22] {\n  border: 2px solid #d2f5ce;\n}\n.img-review-wrapper > .img-item > img[data-v-4226ba22] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.img-review-wrapper > .img-item.upload-images[data-v-4226ba22] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: #edf6ec;\n  color: #000;\n  font-size: 30px;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n}\nbutton.btn-delete-img[data-v-4226ba22] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: absolute;\n  font-size: 10px;\n  top: 0;\n  right: 0;\n  height: 18px;\n  width: 18px;\n  border-radius: 50%;\n  background: #676666;\n  color: #fff;\n}\nbutton.btn-delete-img[data-v-4226ba22]:hover {\n  background: #373737;\n}\n.max-img-notes[data-v-4226ba22] {\n  width: 100%;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 16.8px;\n  font-style: italic;\n}\n.max-img-notes[data-v-4226ba22]::before {\n  content: \"* \";\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',[_c('div',{ref:"extraModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body repricing-modal"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"evidence-contact-wrapper",staticStyle:{"margin-top":"20px"}},[_c('h4',{staticClass:"title-evidence"},[_vm._v("\n                  1. Evidence of attempts to contact pax\n                ")]),_vm._v(" "),_c('p',{staticClass:"subtitile-evidence"},[_vm._v("\n                  Upload a screenshot of your attempts to contact the\n                  passenger.\n                ")]),_vm._v(" "),_c('label',{staticClass:"input-file",attrs:{"for":_vm.evidenceContactPaxList.length
                      ? 'input-evidence-contact-disable'
                      : 'input-evidence-contact'}},[_c('img',{class:_vm.evidenceContactPaxList.length &&
                      _vm.previewContactPax &&
                      'preview-active',attrs:{"src":_vm.evidenceContactPaxList.length && _vm.previewContactPax
                        ? _vm.previewContactPax.imagePreview
                        : '/static/assets/images/input-file.png',"alt":"upload-image"}})]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-evidence-contact","accept":".jpg,.jpeg,.png","multiple":""},on:{"change":function($event){return _vm.uploadEvidence($event.target.files, 1)}}}),_vm._v(" "),_c('div',{staticClass:"img-review-wrapper"},[(
                      _vm.evidenceContactPaxList.length &&
                      _vm.evidenceContactPaxList.length !== 5
                    )?_c('label',{staticClass:"img-item upload-images",attrs:{"for":"input-evidence-contact"}},[_vm._v("\n                    +\n                  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.evidenceContactPaxList),function(img,key){return _c('div',{key:key,class:img.id === _vm.previewContactPax.id
                        ? 'img-item active'
                        : 'img-item',on:{"click":function($event){return _vm.setPreviewContactImage(img, 1)}}},[_c('img',{attrs:{"src":img.imagePreview,"alt":img.id}}),_vm._v(" "),_c('button',{staticClass:"btn-delete-img",on:{"click":function($event){return _vm.deleteImagePreview(img.id, 1)}}},[_vm._v("\n                      X\n                    ")])])}),_vm._v(" "),_c('p',{staticClass:"max-img-notes"},[_vm._v("You can upload up to 5 images.")])],2)]),_vm._v(" "),_c('div',{staticClass:"evidence-vehicle-wrapper"},[_c('h4',{staticClass:"title-evidence"},[_vm._v("\n                  2. Evidence of your vehicle on location\n                ")]),_vm._v(" "),_c('p',{staticClass:"subtitile-evidence"},[_vm._v("\n                  Photo of your vehicle on the site with time stamp and\n                  location.\n                ")]),_vm._v(" "),_c('label',{staticClass:"input-file",attrs:{"for":_vm.evidenceVehicleList.length
                      ? 'input-evidence-vehicle-disable'
                      : 'input-evidence-vehicle'}},[_c('img',{class:_vm.evidenceVehicleList.length &&
                      _vm.previewVehicle &&
                      'preview-active',attrs:{"src":_vm.evidenceVehicleList.length && _vm.previewVehicle
                        ? _vm.previewVehicle.imagePreview
                        : '/static/assets/images/input-file.png',"alt":"upload-image"}})]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":"input-evidence-vehicle","accept":".jpg,.jpeg,.png","multiple":""},on:{"change":function($event){return _vm.uploadEvidence($event.target.files, 2)}}}),_vm._v(" "),_c('div',{staticClass:"img-review-wrapper"},[(
                      _vm.evidenceVehicleList.length &&
                      _vm.evidenceVehicleList.length !== 5
                    )?_c('label',{staticClass:"img-item upload-images",attrs:{"for":"input-evidence-vehicle"}},[_vm._v("\n                    +\n                  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.evidenceVehicleList),function(img,key){return _c('div',{key:key,class:img.id === _vm.previewVehicle.id
                        ? 'img-item active'
                        : 'img-item',on:{"click":function($event){return _vm.setPreviewContactImage(img, 2)}}},[_c('img',{attrs:{"src":img.imagePreview,"alt":img.id}}),_vm._v(" "),_c('button',{staticClass:"btn-delete-img",on:{"click":function($event){return _vm.deleteImagePreview(img.id, 2)}}},[_vm._v("\n                      X\n                    ")])])}),_vm._v(" "),_c('p',{staticClass:"max-img-notes"},[_vm._v("You can upload up to 5 images.")])],2)]),_vm._v(" "),_c('div',{staticClass:"description-wrapper"},[_c('label',{staticClass:"input-std",attrs:{"for":"description"}},[_vm._v("\n                  Description\n                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.notes),expression:"data.notes"}],staticClass:"form-control",attrs:{"name":"description","id":"description","cols":"30","rows":"10","placeholder":"Provide more details about the situation."},domProps:{"value":(_vm.data.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data, "notes", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"confirm-btn-wrapper"},[_c('button',{staticClass:"btn btn-submit",staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.enabledConfirmBtn},on:{"click":function($event){return _vm.confirmPaxNoShow()}}},[_vm._v("\n                  Confirm\n                ")])])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-end items-center"},[_c('button',{staticClass:"close btn-close-modal",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 871:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormEditLogging_vue__ = __webpack_require__(717);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282cda0f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormEditLogging_vue__ = __webpack_require__(874);
function injectStyle (ssrContext) {
  __webpack_require__(872)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-282cda0f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormEditLogging_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282cda0f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormEditLogging_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(873);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("0c8784e1", content, true, {});

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".modal-body.repricing-modal[data-v-282cda0f]{padding:15px 20px}.btn.btn-submit[data-v-282cda0f]{background:#4fb848}.btn.btn-cancel[data-v-282cda0f],.btn.btn-submit[data-v-282cda0f]{font-size:.8667rem;border-radius:5px;border:transparent;font-weight:900;-webkit-box-shadow:0 2px 8px -5px #4c4c4c;box-shadow:0 2px 8px -5px #4c4c4c;color:#fff;padding:10px 20px;text-transform:uppercase;outline:none}.btn.btn-cancel[data-v-282cda0f]{background:#a0a0a0}.btn.btn-submit[data-v-282cda0f]:hover{background:#339c2b}.btn.btn-cancel[data-v-282cda0f]:hover{background:#888}.gap-10[data-v-282cda0f]{gap:10px}.utc-zone[data-v-282cda0f]{color:#939396;font-weight:600}", "", {"version":3,"sources":["/app/src/components/shared/FormEditLogging.vue"],"names":[],"mappings":"AACA,6CACE,iBAAmB,CACpB,AACD,iCACE,kBAAoB,CAWrB,AACD,kEAXE,mBAAqB,AACrB,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,0CAA6C,AAC7C,kCAAqC,AACrC,WAAY,AACZ,kBAAmB,AACnB,yBAA0B,AAC1B,YAAc,CAcf,AAZD,iCACE,kBAAoB,CAWrB,AACD,uCACE,kBAAoB,CACrB,AACD,uCACE,eAAoB,CACrB,AACD,yBACE,QAAU,CACX,AACD,2BACE,cAAe,AACf,eAAiB,CAClB","file":"FormEditLogging.vue","sourcesContent":["\n.modal-body.repricing-modal[data-v-282cda0f] {\n  padding: 15px 20px;\n}\n.btn.btn-submit[data-v-282cda0f] {\n  background: #4fb848;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-cancel[data-v-282cda0f] {\n  background: #a0a0a0;\n  font-size: 0.8667rem;\n  border-radius: 5px;\n  border: transparent;\n  font-weight: 900;\n  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;\n  box-shadow: 0px 2px 8px -5px #4c4c4c;\n  color: #fff;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  outline: none;\n}\n.btn.btn-submit[data-v-282cda0f]:hover {\n  background: #339c2b;\n}\n.btn.btn-cancel[data-v-282cda0f]:hover {\n  background: #888888;\n}\n.gap-10[data-v-282cda0f] {\n  gap: 10px;\n}\n.utc-zone[data-v-282cda0f] {\n  color: #939396;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 874:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',[_c('div',{ref:"extraModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-md"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body repricing-modal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-between items-center"},[_c('h4',{staticStyle:{"font-weight":"800"}},[_vm._v("Edit Trip Log")]),_vm._v(" "),_c('button',{staticClass:"close btn-close-modal",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('form',{staticStyle:{"margin-top":"20px"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Date")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"label":"Select date","id":"date","color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD, YYYY","min-date":_vm.disabledDates,"auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[[_c('label',{staticClass:"required"},[_vm._v("Time")]),_vm._v(" "),_c('span',{staticClass:"utc-zone"},[_vm._v("("+_vm._s(_vm.timeZone)+")")])],_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"label":"Select time","id":"time","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","only-time":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.form.time),callback:function ($$v) {_vm.$set(_vm.form, "time", $$v)},expression:"form.time"}})],2)]),_vm._v(" "),_vm._m(0)])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-end gap-10 items-center"},[_c('button',{staticClass:"btn btn-submit",attrs:{"type":"submit"}},[_vm._v("\n                      Submit\n                    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 875:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompleteTripLog_vue__ = __webpack_require__(718);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681cc3a3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompleteTripLog_vue__ = __webpack_require__(876);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompleteTripLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681cc3a3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompleteTripLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',[_c('div',{ref:"vue_modal_complete_trip_log",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-complete-trip"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v(_vm._s(_vm.data.reservationCode))]),_vm._v(" "),_c('span',[_vm._v("Last State: "+_vm._s(_vm.data.workflow.current.description))])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"complete-trip-wrapper"},[_c('h4',[_vm._v("Passenger Details")]),_vm._v(" "),_c('div',{staticClass:"pax-name"},[_vm._v(_vm._s(_vm.data.passenger.fullName))]),_vm._v(" "),_c('div',{staticClass:"service-type"},[_c('ul',[(_vm.data.serviceType === 'AirportTransfer')?_c('li',[_c('i',{staticClass:"ic-flight-icon"}),_vm._v("Airport Transfer\n                  ")]):_c('li',[_c('i',{staticClass:"ic-time"}),_vm._v("Hourly Booking")])])]),_vm._v(" "),_c('div',{staticClass:"reservation-location"},[_c('div',{staticClass:"pickup-wrapper"},[_c('div',{staticClass:"area"},[_c('span',[_vm._v("Pick Up Area")]),_vm._v(" "),_c('div',{staticClass:"location"},[_vm._v("\n                      "+_vm._s(_vm.data.pickUpLocation.name)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"date-time"},[_c('div',{staticClass:"rent-date"},[_c('i',{staticClass:"ic-date-picker"}),_vm._v("\n                      "+_vm._s(_vm.$helper.dateFormatted(_vm.data.pickUpDateTime.dateTime))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"rent-time"},[_c('i',{staticClass:"ic-time"}),_vm._v("\n                      "+_vm._s(_vm.$helper.timeFormatted(_vm.data.pickUpDateTime.dateTime))+"\n\n                      "),_c('span',{staticClass:"utc-zone"},[_vm._v(_vm._s(_vm.data.pickUpDateTime.timezone))])])])]),_vm._v(" "),_c('div',{staticClass:"dropoff-wrapper text-right"},[_c('div',{staticClass:"area"},[_c('span',[_vm._v("Drop Off Area")]),_vm._v(" "),_c('div',{staticClass:"location"},[_vm._v("\n                      "+_vm._s(_vm.data.dropOffLocation.name)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"date-time"},[_c('div',{staticClass:"rent-date"},[_vm._v("\n                      "+_vm._s(_vm.$helper.dateFormatted(_vm.data.dropOffDateTime.dateTime))+"\n                      "),_c('i',{staticClass:"ic-date-picker"})]),_vm._v(" "),_c('div',{staticClass:"rent-time"},[_vm._v("\n                      "+_vm._s(_vm.$helper.timeFormatted(_vm.data.dropOffDateTime.dateTime))+"\n                      "),_c('span',{staticClass:"utc-zone"},[_vm._v(_vm._s(_vm.data.dropOffDateTime.timezone))]),_vm._v(" "),_c('i',{staticClass:"ic-time"})])])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"complete-trip-wrapper"},[_c('h4',{staticClass:"mt-20"},[_vm._v("Post-Booking Extras")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"0"},attrs:{"id":"form-contact"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"row d-flex justify-start items-center"},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model[0].active),expression:"model[0].active"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model[0].active)?_vm._i(_vm.model[0].active,null)>-1:(_vm.model[0].active)},on:{"change":function($event){var $$a=_vm.model[0].active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model[0], "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model[0], "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model[0], "active", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle text-filter"},[_vm._v("\n                          Parking\n                        ")])])]),_vm._v(" "),(_vm.model[0].active)?_c('div',{staticClass:"col-sm-4"},[_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Currency","label":"label","options":_vm.currencyOptions,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model[0].currency),callback:function ($$v) {_vm.$set(_vm.model[0], "currency", $$v)},expression:"model[0].currency"}})],1):_vm._e(),_vm._v(" "),(_vm.model[0].active)?_c('div',{staticClass:"col-sm-4"},[_c('div',[_c('currency-input',{staticClass:"form-control",attrs:{"autocomplete":"off","placeholder":"Enter rate","allow-negative":true,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model[0].rate),callback:function ($$v) {_vm.$set(_vm.model[0], "rate", $$v)},expression:"model[0].rate"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.model[0].active && _vm.model[0].imagePreview)?_c('div',{staticClass:"row mt-10"},[_c('div',{staticClass:"col-sm-12"},[(_vm.model[0].imagePreview)?_c('div',{staticClass:"img__box"},[_c('img',{attrs:{"src":_vm.model[0].imagePreview,"alt":"post-booking-post-image"}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.model[0].active)?_c('div',{staticClass:"row mt-10"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"btn-upload-wrapper"},[_vm._m(1),_vm._v(" "),_c('input',{attrs:{"id":"image-uploader","type":"file","name":"imageData","accept":"image/jpeg,image/png"},on:{"change":function($event){return _vm.onChangeImage($event.target.files, 'parking')}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row d-flex justify-start items-center mt-10"},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model[1].active),expression:"model[1].active"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model[1].active)?_vm._i(_vm.model[1].active,null)>-1:(_vm.model[1].active)},on:{"change":function($event){var $$a=_vm.model[1].active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model[1], "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model[1], "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model[1], "active", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle text-filter"},[_vm._v("\n                          Road Toll\n                        ")])])]),_vm._v(" "),(_vm.model[1].active)?_c('div',{staticClass:"col-sm-4"},[_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Currency","label":"label","options":_vm.currencyOptions,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.model[1].currency),callback:function ($$v) {_vm.$set(_vm.model[1], "currency", $$v)},expression:"model[1].currency"}})],1):_vm._e(),_vm._v(" "),(_vm.model[1].active)?_c('div',{staticClass:"col-sm-4"},[_c('div',[_c('currency-input',{staticClass:"form-control",attrs:{"autocomplete":"off","placeholder":"Enter rate","allow-negative":true,"currency":null,"locale":_vm.moneyFormat.cultureCode,"precision":_vm.moneyFormat.numberOfDecimal},model:{value:(_vm.model[1].rate),callback:function ($$v) {_vm.$set(_vm.model[1], "rate", $$v)},expression:"model[1].rate"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.model[1].active && _vm.model[1].imagePreview)?_c('div',{staticClass:"row mt-10"},[_c('div',{staticClass:"col-sm-12"},[(_vm.model[1].imagePreview)?_c('div',{staticClass:"img__box"},[_c('img',{attrs:{"src":_vm.model[1].imagePreview,"alt":"post-booking-post-image"}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.model[1].active)?_c('div',{staticClass:"row mt-10"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"btn-upload-wrapper"},[_vm._m(2),_vm._v(" "),_c('input',{attrs:{"id":"image-uploader","type":"file","name":"imageData","accept":"image/jpeg,image/png"},on:{"change":function($event){return _vm.onChangeImage($event.target.files, 'toll')}}})])])]):_vm._e(),_vm._v(" "),(_vm.showWaitingTime)?_c('div',{staticClass:"row d-flex justify-start mt-10"},[_c('div',{staticClass:"col-sm-5"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model[2].active),expression:"model[2].active"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model[2].active)?_vm._i(_vm.model[2].active,null)>-1:(_vm.model[2].active)},on:{"change":function($event){var $$a=_vm.model[2].active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model[2], "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model[2], "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model[2], "active", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle text-filter"},[_vm._v("\n                          Pick-up Waiting\n                        ")])])]),_vm._v(" "),(_vm.model[2].active)?_c('div',{staticClass:"col-sm-7"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.model[2].quantity),expression:"model[2].quantity",modifiers:{"number":true}}],staticClass:"form-control numbers-only",attrs:{"type":"text","name":"arrival-waiting-time","placeholder":"Enter quantity"},domProps:{"value":(_vm.model[2].quantity)},on:{"keyup":function (e) { return _vm.handleKeyUpQuantity(e.target.value); },"blur":[function (e) { return _vm.handleBlurQuantity(e.target.value); },function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model[2], "quantity", _vm._n($event.target.value))}}})]),_vm._v(" "),_c('span',{staticClass:"sts-danger text-center"},[_vm._v(_vm._s(_vm.allowedTime)+" minutes allowed")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-complete-job",attrs:{"type":"submit","disabled":_vm.disabledBtnComplete}},[_vm._v("\n                    Complete\n                  ")])])])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"complete-trip-wrapper"},[_c('div',{staticClass:"warning-alert-upload mt-20"},[_c('div',{staticClass:"img-warning"},[_c('img',{attrs:{"src":"/static/assets/images/warning.svg","alt":"warning-images","width":"20","height":"20"}})]),_vm._v(" "),_c('span',[_vm._v("You'll need to upload a photo of the receipt and enter the\n                  cost of any extra services before you mark the trip as\n                  completed.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-upload"},[_c('i',{staticClass:"ic-up"}),_vm._v("\n                          Parking Photos\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-upload"},[_c('i',{staticClass:"ic-up"}),_vm._v("\n                          Toll Fare Photos\n                        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading)?_c('section',{staticClass:"reservation-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"header--reservation-detail"},[_c('div',{staticClass:"header--reservation-box"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb mb-35 pz"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":_vm.fromTenant ? '/job/tenant' : '/job/provider'}},[_vm._v("\n                      Manage Reservation\n                    ")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                    Reservation Logging\n                  ")])])]),_vm._v(" "),_c('h4',[_vm._v("Reservation Details")]),_vm._v(" "),_c('div',{staticClass:"table-legend"},[_c('ul',[(_vm.isAirportTransfer && _vm.isArrivedFlight)?_c('li',[_c('i',{staticClass:"ic-flight-icon"}),_vm._v("Airport Transfer\n                  ")]):_vm._e(),_vm._v(" "),(_vm.isAirportTransfer && _vm.isDepartureFlight)?_c('li',[_c('i',{staticClass:"ic-flight-departure-icon"}),_vm._v("Airport Transfer\n                  ")]):(
                      _vm.isAirportTransfer &&
                      !_vm.isArrivedFlight &&
                      !_vm.isDepartureFlight
                    )?_c('li',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]),_vm._v("\n                    Point to Point\n                  ")]):(!_vm.isAirportTransfer)?_c('li',[_c('i',{staticClass:"ic-time"}),_vm._v("Hourly Booking\n                  ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Reservation Code")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v(_vm._s(_vm.reservation.reservationCode))])])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Reservation Date")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v("\n                  "+_vm._s(_vm.$helper.dateFormatted(
                      _vm.reservation.reservationDateTime.dateTime
                    ))+"\n                ")])])]),_vm._v(" "),(_vm.driver && _vm.driver.fullName)?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Driver Name")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v("\n                  "+_vm._s(_vm.driver.title ? ((_vm.driver.title) + ".") : "")+"\n                  "+_vm._s(_vm.driver.fullName))])])]):_vm._e(),_vm._v(" "),(_vm.vehicle && _vm.vehicle.plateNumber)?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Vehicle Number")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v(" "+_vm._s(_vm.vehicle.plateNumber)+" ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"body--reservation-detail"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-businessmen --green pull-left mr-10"}),_vm._v(" "),_c('h4',{staticClass:"--green"},[_vm._v("Passenger Details")]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.reservation.passenger.title)+".\n                    "+_vm._s(_vm.reservation.passenger.fullName)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.reservation.passenger.phoneCode &&
                      _vm.reservation.passenger.phoneNumber
                        ? ("(+" + (_vm.reservation.passenger.phoneCode) + ") " + (_vm.reservation.passenger.phoneNumber))
                        : "N/A")+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 divider-left text-right"},[_c('h4',[_vm._v("Booker")]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.reservation.booker.title)+".\n                    "+_vm._s(_vm.reservation.booker.fullName)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.reservation.booker.phoneCode &&
                      _vm.reservation.booker.phoneNumber
                        ? ("(+" + (_vm.reservation.booker.phoneCode) + ") " + (_vm.reservation.booker.phoneNumber))
                        : "N/A")+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"passenger-flight-info"},[(_vm.reservation.noteToDriver)?_c('div',[_c('h4',{staticStyle:{"margin-top":"15px"}},[_vm._v("Notes to Driver")]),_vm._v(" "),_c('div',{staticClass:"passenger-notes"},[_vm._v("\n                "+_vm._s(_vm.reservation.noteToDriver)+"\n              ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box-addons mt-20"},[_c('div',{staticClass:"panel-group",attrs:{"id":"accordion"}},[_c('div',{staticClass:"panel panel-default"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse in",attrs:{"id":"collapse1"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"trip-info"},_vm._l((_vm.reservation.tripLogs),function(log,index){return _c('div',{key:index},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"time__depart"},[_c('div',{staticClass:"time_Is"},[_vm._v("\n                              "+_vm._s(_vm.$helper.timeFormattedFull(
                                  log.timeStamp.dateTime
                                ))+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"date_Is"},[_vm._v("\n                              ("+_vm._s(log.timeStamp.timezone)+")\n                            ")]),_vm._v(" "),_c('div',{staticClass:"date_Is"},[_vm._v("\n                              "+_vm._s(_vm.$helper.dateFormatted(log.timeStamp.dateTime))+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{class:[
                              index === _vm.reservation.tripLogs.length - 1
                                ? 'end-time-stamp'
                                : 'time-stamp',
                              log.event.toLowerCase().includes('dropped')
                                ? 'dropped'
                                : '' ]},[_c('div',{staticClass:"stamp-status d-flex items-center --green"},[_c('span',[_vm._v(_vm._s(log.event))]),_vm._v(" "),(
                                  _vm.showEditable(log.event) &&
                                  _vm.userType === 'TenantUser'
                                )?_c('button',{staticClass:"ml-5 btn-edit-alt",on:{"click":function($event){return _vm.handleEditLog(
                                    log,
                                    _vm.reservation.pickUpDateTime
                                  )}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24 24"}},[_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9 15h3l8.5-8.5a1.5 1.5 0 0 0-3-3L9 12v3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16 5l3 3"}})])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"stamp-desc"},[_vm._v("\n                              "+_vm._s("User : " + log.createdBy)+"\n                            ")])])])])}),0)])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"reservation-summary--small"},[_c('div',{staticClass:"route-card mb-30 bb-1",class:{
                'grid-cols-1fr': _vm.dropOffLocation === 'Same Location',
              }},[_c('div',{staticClass:"route-column pickup"},[_c('div',{staticClass:"name-location",class:{ rental: !_vm.isAirportTransfer },attrs:{"title":_vm.pickUpLocation}},[_vm._v("\n                  "+_vm._s(_vm.pickUpLocation)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"address-location"},[_vm._v("\n                  "+_vm._s(_vm.pickUpLocationAddress)+"\n                ")]),_vm._v(" "),_c('a',{staticClass:"link-location --green",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.onClickOpenDetailLocation(_vm.reservation.pickUpLocation)}}},[_vm._v("View pick-up point")]),_vm._v(" "),_c('div',{staticClass:"datetime"},[_c('div',{staticClass:"rent-date"},[_c('i',{staticClass:"ic-date-picker"}),_vm._v("\n                    "+_vm._s(_vm.$helper.dateFormatted(
                        _vm.reservation.pickUpDateTime.dateTime
                      ))+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"rent-time"},[_c('i',{staticClass:"ic-time"}),_vm._v("\n                    "+_vm._s(_vm.$helper.timeFormatted(
                        _vm.reservation.pickUpDateTime.dateTime
                      ))+"\n                    "),_c('span',{staticClass:"utc-zone"},[_vm._v("("+_vm._s(_vm.reservation.pickUpDateTime.timezone)+")")])]),_vm._v(" "),(_vm.reservation.serviceType.toLowerCase() === 'rental')?_c('div',{staticClass:"rent-time"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('span',{staticClass:"utc-zone"},[_vm._v(_vm._s(_vm.getHours.hours)+"\n                      "+_vm._s(_vm.getHours.hours > 1 ? "Hours" : "Hour"))])]):_vm._e()])]),_vm._v(" "),(_vm.dropOffLocation !== 'Same Location')?_c('div',{staticClass:"route-column dropoff"},[_c('div',{staticClass:"name-location",attrs:{"title":_vm.dropOffLocation}},[_vm._v("\n                  "+_vm._s(_vm.dropOffLocation)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"address-location"},[_vm._v("\n                  "+_vm._s(_vm.dropOffLocationAddress)+"\n                ")]),_vm._v(" "),_c('a',{staticClass:"link-location --green",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.onClickOpenDetailLocation(_vm.reservation.dropOffLocation)}}},[_vm._v("View drop-off point")]),_vm._v(" "),_c('div',{staticClass:"datetime"},[_c('div',{staticClass:"rent-date"},[_vm._v("\n                    "+_vm._s(_vm.$helper.dateFormatted(
                        _vm.reservation.dropOffDateTime.dateTime
                      ))+"\n                    "),_c('i',{staticClass:"ic-date-picker",staticStyle:{"margin-left":"4px"}})]),_vm._v(" "),_c('div',{staticClass:"rent-time"},[_vm._v("\n                    "+_vm._s(_vm.$helper.timeFormatted(
                        _vm.reservation.dropOffDateTime.dateTime
                      ))+"\n                    "),_c('span',{staticClass:"utc-zone"},[_vm._v("("+_vm._s(_vm.reservation.dropOffDateTime.timezone)+")")]),_vm._v(" "),_c('i',{staticClass:"ic-time",staticStyle:{"margin-left":"4px"}})])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cRow"},[[_c('div',{staticClass:"col-sm-12"},[_c('img',{staticClass:"cars-image",attrs:{"src":(_vm.reservation.vehicle && _vm.reservation.vehicle.imageUri) ||
                      _vm.vehicle.imageUri,"alt":""}})])]],2),_vm._v(" "),_c('div',{staticClass:"type-car"},[_vm._v(_vm._s(_vm.reservation.vehicle.className))]),_vm._v(" "),_c('div',{staticClass:"cars-brand"},[_vm._v("\n              "+_vm._s(_vm.reservation.vehicle.factoryName)+"\n              "+_vm._s(_vm.reservation.vehicle.brandName)+"\n              "+_vm._s(_vm.reservation.vehicle.plateNumber
                  ? ("(" + (_vm.reservation.vehicle.plateNumber) + ")")
                  : "")+"\n              "),_c('span',{staticClass:"cars-brand-equivalent"},[_vm._v("or equivalent")])]),_vm._v(" "),(
                _vm.hasPaxCapacity ||
                _vm.hasLargeBaggageCapacity ||
                _vm.hasSmallBaggageCapacity
              )?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[(_vm.hasPaxCapacity)?_c('div',{staticClass:"capacity-seat"},[_vm._v("\n                  Pax Capacity "+_vm._s(_vm.reservation.vehicle.feature.paxCapacity)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.hasLargeBaggageCapacity)?_c('div',{staticClass:"capacity-large-baggage"},[_vm._v("\n                  Large Bag. Capacity x"+_vm._s(_vm.reservation.vehicle.feature.largeBaggageCapacity)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.hasSmallBaggageCapacity)?_c('div',{staticClass:"capacity-baggage"},[_vm._v("\n                  Small Bag. Capacity x"+_vm._s(_vm.reservation.vehicle.feature.smallBaggageCapacity)+"\n                ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),(_vm.isAllowViewAdminNotes && _vm.adminNotes)?_c('div',{staticClass:"admin-section-wrapper mt-20"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v("Admin – For internal use only")]),_vm._v(" "),_c('table',{staticClass:"table-admin-notes"},[(_vm.adminNotes)?_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Admin Notes")]),_vm._v(" "),_c('td',{staticClass:"colon-label"},[_vm._v(":")]),_vm._v(" "),_c('td',{staticClass:"label-value"},[_vm._v(_vm._s(_vm.adminNotes))])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.showButtonNext || (_vm.showButtonCompleteTrip && !_vm.progressDone))?_c('div',{staticClass:"button-wrapper-log"},[(_vm.showButtonCompleteTrip && !_vm.progressDone)?_c('button',{staticClass:"btn btn-complete-trip",on:{"click":function($event){return _vm.openCompleteTrip()}}},[_c('span',[_vm._v("Complete Trip")]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248s248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200c0 110.532-89.451 200-200 200c-110.532 0-200-89.451-200-200c0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z","fill":"currentColor"}})])]):_vm._e(),_vm._v(" "),(_vm.showButtonNext)?_c('button',{staticClass:"btn btn-next",staticStyle:{"text-wrap":"wrap","white-space":"normal","word-break":"break-word"},on:{"click":function($event){return _vm.nextState()}}},[_c('span',[_vm._v(_vm._s(_vm.reservation.workflow.next.description))]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 32 32"}},[_c('defs'),_vm._v(" "),_c('path',{attrs:{"d":"M2 16A14 14 0 1 0 16 2A14 14 0 0 0 2 16zm6-1h12.15l-5.58-5.607L16 8l8 8l-8 8l-1.43-1.427L20.15 17H8z","fill":"currentColor"}})])]):_vm._e(),_vm._v(" "),(_vm.reservation.workflow.next.event === 14)?_c('button',{staticClass:"btn btn-no-show mt-10",staticStyle:{"text-wrap":"wrap","white-space":"normal","word-break":"break-word"},on:{"click":function($event){return _vm.openModalPaxNoShow()}}},[_c('span',[_vm._v("Passenger No Show / Cancelled")])]):_vm._e()]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('div',{ref:"mapmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('mapModal')],1)])])]),_vm._v(" "),_c('FormLogging',{on:{"submit":_vm.onSubmitLogging}}),_vm._v(" "),_c('FormEditLogging',{on:{"submit":_vm.onSubmitEditLogging}}),_vm._v(" "),_c('CompleteTripLog',{on:{"finish":_vm.onSubmitCompleteTrip}}),_vm._v(" "),_c('PaxNoShow',{on:{"confirm":_vm.confirmPaxNoShow}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading text-center"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"--green",attrs:{"data-toggle":"collapse","data-parent":"#accordion","href":"#collapse1"}},[_c('i',{staticClass:"ic-History mr-10"}),_vm._v("Reservation Logging\n                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"ic-close"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.5716f71d03209f4acc44.js